import { PremiumStoreFormValues } from '../premiumStore.schema';

type BuildPremiumStorePayloadParams = {
  formData: PremiumStoreFormValues;
  kycFrontImageUrl: string;
  kycBackImageUrl: string;
  profileImageUrl: string;
  coverImageUrl: string;

  passportImageUrl?: string;
  insuranceCardImageUrl?: string;
  businessCertificateImageUrl?: string;
  corporateRegistryImageUrl?: string;
};

export function buildPremiumStorePayload({
  formData,
  profileImageUrl,
  coverImageUrl,
  passportImageUrl,
  insuranceCardImageUrl,
  kycBackImageUrl,
  kycFrontImageUrl,
  businessCertificateImageUrl,
  corporateRegistryImageUrl,
}: BuildPremiumStorePayloadParams) {
  return {
    profileImage: profileImageUrl,
    coverImage: coverImageUrl,
    storeName: formData.storeName ?? '',
    storeNameFurigana: formData.storeNameFurigana ?? '',
    groupName: formData.groupName ?? '',
    description: formData.description ?? '',
    businessType: formData.businessType,
    ceoFullName: formData.ceoFullName ?? '',
    ceoFurigana: formData.ceoFurigana ?? '',
    companyName: formData.companyName ?? '',
    companyNameFurigana: formData.companyNameFurigana ?? '',
    companyAddress: formData.companyAddress ?? '',
    landlineNumber: formData.landlineNumber ?? '',
    mobileNumber: formData.mobileNumber ?? '',
    emailAddress: formData.emailAddress ?? '',
    username: formData.username ?? '',
    identificationType: formData.identificationType ?? '',
    passportImage: passportImageUrl ?? '',
    insuranceCardImage: insuranceCardImageUrl ?? '',
    businessCertificateImage: businessCertificateImageUrl ?? '',
    kycFrontImage: kycFrontImageUrl ?? '',
    kycBackImage: kycBackImageUrl ?? '',
    corporateRegistryImage: corporateRegistryImageUrl ?? '',
    businessLicenseNumber: formData.businessLicenseNumber ?? '',
    licenseIssueDate: formData.licenseIssueDate ? new Date(formData.licenseIssueDate).getTime() : 0,
    longitude: formData.longitude ?? '',
    latitude: formData.latitude ?? '',
    postalCode: formData.postalCode ?? '',
    prefecture: formData.prefecture ?? '',
    city: formData.city ?? '',
    street: formData.street ?? '',
    buildingNo: formData.buildingNo ?? '',
    workingTimeFrom: formData.workingTimeFrom ?? '',
    workingTimeTo: formData.workingTimeTo ?? '',
    lastEntryTime: formData.lastEntryTime ?? '',
    holidays: formData.holidays ?? '',
    closingDate: formData.closingDate ?? '',
    otherHolidays: formData.otherHolidays ?? [],
    tax: formData.tax ?? '',
    instagram: formData.instagram ?? '',
    tiktok: formData.tiktok ?? '',
    line: formData.line ?? '',
    twitter: formData.twitter ?? '',
    website: formData.website ?? '',
    googleMap: formData.googleMap ?? '',
  };
}
